'use client'

import React, { useState } from "react";
import OurButton from "../../app/components/ourButton";

const SubscriptionBenefits: React.FC = () => {
  const [hoveredTitle, setHoveredTitle] = useState("Pro");

  const subscriptions = [
    {
      title: "Basic",
      description: "$250/week",
      buttonText: "Subscribe",
      buttonUrl: "/contact",
      extraText:
        "Kickstart your online presence with the Basic package, offering a professional website and comprehensive filling services. It's the perfect foundation for small businesses or startups looking for an affordable way to get online quickly. Gain reliability and simplicity without overcomplicating your digital needs.",
    },
    {
      title: "Pro",
      description: "$400/week",
      buttonText: "Subscribe",
      buttonUrl: "/contact",
      extraText:
        "Looking to grow your reach? The Pro package builds on the Basic plan with additional services like SEO Core and website maintenance. Enjoy better search engine rankings and ongoing support to ensure your site performs at its best. Ideal for businesses aiming to improve visibility and efficiency.",
    },
    {
      title: "Ultra",
      description: "$750/week",
      buttonText: "Subscribe",
      buttonUrl: "/contact",
      extraText:
        "Take your business to the next level with the Ultra package. It includes everything in the Pro plan plus advanced marketing strategies, free board system integration, and modern frameworks for scalability. Enhance your brand's credibility and customer engagement with tailored solutions for a competitive edge.",
    },
    {
      title: "Max",
      description: "$1000/week",
      buttonText: "Subscribe",
      buttonUrl: "/contact",
      extraText:
        "Achieve ultimate digital dominance with the Max package. This all-inclusive plan features mobile app development, graphic design, a professional brandbook, and more. From streamlined frameworks to marketing mastery, Max empowers your business with unparalleled tools for success. Your brand deserves nothing less.",
    },
  ];

  return (
    <div className="flex flex-col gap-8">
      {subscriptions.map((subscription) => (
        <div
          key={subscription.title}
          id={subscription.title.toLowerCase()}
          className={`w-full flex justify-center`}
          onMouseEnter={() => setHoveredTitle(subscription.title)}
          onMouseLeave={() => setHoveredTitle("Pro")}
        >
          <div
            className={`flex justify-center rounded-[25px] item-center flex-col md:flex-row gap-4 md:gap-8 px-4 md:px-8 py-4 w-full md:w-fit transition-all duration-500 ${
              hoveredTitle === subscription.title
                ? "bg-blue-50 shadow-lg"
                : "bg-white"
            }`}
          >
            <div
              className={`flex flex-col p-4 w-full md:w-[350px] rounded-[25px] transition-all duration-500 md:max-w-[350px] items-center md:gap-3 ${
                hoveredTitle === subscription.title
                  ? "bg-[#FAFEFF]"
                  : "bg-white"
              }`}
            >
              <h4 className="w-full text-center normal leading-none">{subscription.title}</h4>
              <p>{subscription.description}</p>
              <OurButton
                href={subscription.buttonUrl}
                textForButton={subscription.buttonText}
                className={`w-full justify-center mt-1 md:mt-0 md:my-2`}
              />
            </div>
            <div className="flex flex-col items-start justify-center gap-2 max-w-[1000px]">
            <p className="font-bold text-[0.85rem]">Min Term of subscription is 6 months</p>
              <p>{subscription.extraText}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionBenefits;
